import { PageContent, Box, Header, Heading, Paragraph, Anchor } from "grommet";
import { PropsWithChildren } from "react";
import { AppPage } from "../components/app-page";
import React from "react";
import { BlockQuote } from "grommet-icons";

const Reviews: React.FC<PropsWithChildren> = () => {
    return (
        <AppPage>
            <>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'cream' }} pad="xlarge">
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "xlarge" }}>
                        <Header direction="column" gap="small" overflow="hidden" className="title-medium">
                            <Heading weight="normal" margin="none" color="cream">reviews</Heading>
                        </Header>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_background' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "medium" }}>
                       <Paragraph color="cream" textAlign="center">The critics are <strong>loving</strong> this union. See for yourself!</Paragraph>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }} style={{paddingTop: "48px"}}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "large" }}>
                        <BlockQuote size="large" color="green_foreground" />
                        <Paragraph size="30px" textAlign="center"><strong>I'd marry him myself!</strong></Paragraph>
                        <Paragraph>- Kevin McVey</Paragraph>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "large" }}>
                    <div style={{width: "60%", borderTop:"4px solid rgba(255, 102, 49, 1)", paddingBottom:"92px"}}></div>

                        <BlockQuote size="large" color="green_foreground" />
                        <Paragraph size="30px" textAlign="center"><strong>Best kid I ever had!</strong></Paragraph>
                        <Paragraph>- Lynetta Binger</Paragraph>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "large" }}>
                    <div style={{width: "60%", borderTop:"4px solid rgba(255, 102, 49, 1)", paddingBottom:"92px"}}></div>

                        <BlockQuote size="large" color="green_foreground" />
                        <Paragraph size="30px" textAlign="center"><strong>I introduced them.</strong></Paragraph>
                        <Paragraph>- Casey Anderson</Paragraph>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }} style={{paddingBottom: "48px"}}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "large" }}>
                    <div style={{width: "60%", borderTop:"4px solid rgba(255, 102, 49, 1)", paddingBottom:"92px"}}></div>

                        <BlockQuote size="large" color="green_foreground" />
                        <Paragraph size="30px" textAlign="center"><strong>Best espousal since Hadrian and Antinous.</strong></Paragraph>
                        <Paragraph>- Nirali Jantrania</Paragraph>
                    </Box>
                </PageContent>
            </>
        </AppPage>
    );
}

export default Reviews;
